import { useEffect, useRef } from 'react';

const EVENT = 'etappio:new-notifications';

/** Called by the notification bell when its poll finds notifications it had not seen. */
export function announceNewNotifications(eventKeys: string[]) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { eventKeys } }));
}

/**
 * Refreshes a page when a new notification arrives, so a change made elsewhere
 * (a contract sent back, a stage started) reaches an open start page without a
 * reload (ClickUp 869fcmr7k).
 */
export function useRefreshOnNotification(refresh: () => Promise<unknown> | void) {
  const callback = useRef(refresh);
  callback.current = refresh;
  useEffect(() => {
    const onNotifications = () => { void Promise.resolve().then(() => callback.current()).catch(() => {}); };
    window.addEventListener(EVENT, onNotifications);
    return () => window.removeEventListener(EVENT, onNotifications);
  }, []);
}
